import { render, staticRenderFns } from "./AuditOjtMaHistory.vue?vue&type=template&id=745d5294&scoped=true"
import script from "./AuditOjtMaHistory.vue?vue&type=script&lang=js"
export * from "./AuditOjtMaHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d5294",
  null
  
)

export default component.exports